const Newsletter = () => {
  return <h1>Newsletter</h1>;
};
export default Newsletter;
